import React from 'react';

interface Props {
  id: string;
}

export const CustomerContracts = ({ id, }:Props) => {
  return (
    <div>
      Umowy { id}
    </div>
  );
};
